<template>
    <div class="flex align-items-center">
        <!-- {{ checkboxValues }} -->

        <Checkbox v-model="checkboxValues" :inputId="inputId" :name="name" :value="value" @change="handleCheckboxChange(inputId)"/>
        <label v-if="label" :for="inputId" :class="$attrs.class">{{ label }}</label>
    </div>
</template>

<script>
import Checkbox from 'primevue/checkbox';
import { v4 as uuid } from 'uuid'

export default {
    components: {
        Checkbox
    },
    data() {
        return {
            checkboxValues: [],
        }
    },
    props: {
        modelValue: { type: Array, default: [] },
        inputId: {
            type: String,
            default() {
                return `check-input-${uuid()}`
            },
        },
        name: {
            type: String,
        },
        value: [String , Number],
        label: String,

    },
    mounted() {
        this.checkboxValues = this.modelValue;
    },
    watch: {
        modelValue(modelValue) {
            this.checkboxValues = modelValue
        },
    },
    methods: {
        isChecked(option) {
            return this.modelValue.indexOf(option.inputId) >= 0
        },
        handleCheckboxChange(value) {
            let mValue = this.modelValue;
            if(mValue.indexOf(value) >= 0){
                mValue.splice(mValue.indexOf(value), 1);
            }else{
                mValue.push(value);
            }
            this.$emit('update:modelValue', mValue)
        },
    },
}
</script>